import { Tooltip } from 'antd';
import { orderBy } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ContainerPontos } from './styled';

//APP
import { leadZero } from '../../../../../../../../../../../../utils';
import type { GeoPointFeature } from '../../../../types';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom';


interface Props {
    initialPoints: GeoPointFeature[]
    inserirPontosSelecionados: (pontos: GeoPointFeature[], id: string | number, cod_analise: number) => void
    id: string | number
    cod_analise: number
    removerPonto: (analiseId: string | number, pontoNome: number | string) => void
    /** Desabilita a edição (enquanto o modal de nova análise não foi migrado). */
    disabledInserir?: boolean
}

/** Grade de "chips" com os pontos de uma análise + botão para editar a seleção. */
export function PontosAnalises({ initialPoints = [], inserirPontosSelecionados, id, cod_analise, removerPonto, disabledInserir }: Props) {

    const lista_pontos_ordenados = orderBy(initialPoints, 'NOME');

    return (
        <ContainerPontos>
            <h3 className='points-title'>Pontos</h3>

            <div className='points-grid'>
                {lista_pontos_ordenados.map((point, index) => (
                    <div key={index} className='point-card' style={{ backgroundColor: point?.COR ?? undefined }}>
                        {leadZero(point?.NOME)}
                        <button
                            className='point-card__remove'
                            onClick={(e) => {
                                e.stopPropagation()
                                removerPonto(id, point?.NOME)
                            }}
                            title='Remover ponto'
                        >
                            <FontAwesomeIcon icon={faXmark} style={{ fontSize: 10 }} />
                        </button>
                    </div>
                ))}

                <Tooltip title="Inserir ponto"><samp>
                    <ButtonCustom
                        style={{ height: 35, textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}
                        type='secondary'
                        onClick={() => inserirPontosSelecionados(initialPoints, id, cod_analise)}
                        icon={<FontAwesomeIcon icon={faPlus} />}
                        disabled={disabledInserir}
                    />
                </samp></Tooltip>
            </div>
        </ContainerPontos>
    )
};